export default "__VITE_ASSET__DLcy0qj0__"